const ANGEL_INVESTOR_STATUS = {
  approved: 'approved',
  rejected: 'rejected',
  pending: 'pending',
};

export default ANGEL_INVESTOR_STATUS;
